import { render, staticRenderFns } from "./EmployeeTrainingDetailHeader.vue?vue&type=template&id=687d8962&"
import script from "./EmployeeTrainingDetailHeader.vue?vue&type=script&lang=ts&"
export * from "./EmployeeTrainingDetailHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports